<script>

    import { toast } from 'bulma-toast'
    import { modalStore } from '../stores'

    import ChargesService from '../$services/charges.service'

    import File from '../$components/file.svelte'
    import Form from '../$components/form.svelte'
    import Button from '../$components/button.svelte'
    import ButtonSave from '../$components/button.save.svelte'

    let data = {}
    let loading = false

    async function uploadCharges() {
    
        loading = true
        const resp = await ChargesService.uploadCharges(data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        toast({message: `${resp.data} Cargos subidos`, type: 'is-success'})
    }

</script>

<Form on:submit={uploadCharges} {loading} >
    
    <File bind:file={data.chargesFile} />

    <a href="/files/cargos_template.csv" download="cargos_template.csv">Descargar plantilla</a>

    <div class="is-flex is-justify-content-flex-end is-align-items-center">
        <Button on:click={modalStore.close} text="Cancelar" icon="ban" />
        <ButtonSave icon="edit" text="Actualizar" { loading } />
    </div>
</Form>